import { Tabs } from './tabs.js';
import { initBtnScroll } from '../init-btn-scroll.js';

let tabs;

const initTabs = () => {
  initBtnScroll();

  tabs = new Tabs();
  window.tabs = tabs;

};

export { initTabs, tabs };
